const baseUrl = "https://www.ktig.info";

const metaConfig = {
  home: {
    title: "Kovai Tech India Group - KTIG | Comprehensive Sector",
    description:
      "KTIG offers comprehensive solutions across banking, finance, investment, IT, non-IT, sales, education, insurance, and marketing to drive growth and success.",
    keywords:
      "KTIG offers, solutions across banking, finance, investment, IT, non-IT, sales, education, insurance, and marketing ",
    canonical: `${baseUrl}/`,
  },

  about: {
    title: "Kovai Tech India Group - KTIG | Innovation, Growth & Success",
    description:
      "Kovai Tech India Group (KTIG) unites Kovai Tech Member Chamber, BNR Cogniitec Pvt Ltd, and BR Academy to drive innovation, growth, and business excellence.",
    keywords:
      "Kovai Tech India Group (KTIG) unites Kovai Tech Member Chamber, BNR Cogniitec Pvt Ltd, and BR Academy to drive innovation, growth, and business excellence.",
    canonical: `${baseUrl}/about-ktig`,
  },
  visionandmission: {
    title: " KTIG| Innovating for a Sustainable and Connected Future",
    description:
      "KTIG strives to lead innovation and technology, empowering businesses with cutting-edge solutions for sustainable growth, efficiency, and global impact.",
    keywords:
      "KTIG strives to lead innovation and technology, empowering businesses with cutting-edge solutions for sustainable growth, efficiency, and global impact.",
    canonical: `${baseUrl}/vision-mission`,
  },
  directorsboard: {
    title: " KTIG Board | BNR Cogniitec | Kovai Tech Chamber | BR Academy",
    description:
      "KTIG unites BNR Cogniitec, Kovai Tech Member Chamber, and BR Academy, fostering innovation, leadership, and excellence across industries.",
    keywords:
      "KTIG unites BNR Cogniitec, Kovai Tech Member Chamber, and BR Academy, fostering innovation, leadership, and excellence across industries.",
    canonical: `${baseUrl}/board-of-directories`,
  },
  directorsdetails: {
    title: " KTIG Board | BNR Cogniitec | Kovai Tech Chamber | BR Academy",
    description:
      "KTIG unites BNR Cogniitec, Kovai Tech Member Chamber, and BR Academy, fostering innovation, leadership, and excellence across industries.",
    keywords:
      "KTIG unites BNR Cogniitec, Kovai Tech Member Chamber, and BR Academy, fostering innovation, leadership, and excellence across industries.",
    canonical: `${baseUrl}/board-of-directories-details`,
  },
  ktnl: {
    title: " Kovai Tech Nidhi Ltd | FD, RD, Savings & Loan Services",
    description:
      " Kovai Tech Nidhi Ltd offers fixed deposits, recurring deposits, savings accounts, and loan services to ensure secure and reliable financial growth.",
    keywords:
      " Kovai Tech Nidhi Ltd offers fixed deposits, recurring deposits, savings accounts, and loan services to ensure secure and reliable financial growth.",
    canonical: `${baseUrl}/kovai-tech-nidhi-limited`,
  },
  ktmc: {
    title: "  KTMC | Premier Business Networking & Growth Hub",
    description:
      " KTMC is a premier business networking hub, fostering collaboration, innovation, and growth through strategic partnerships and knowledge exchange.",
    keywords:
      " KTMC is a premier business networking hub, fostering collaboration, innovation, and growth through strategic partnerships and knowledge exchange.",
    canonical: `${baseUrl}/kovai-tech-member-chamber`,
  },
  bnrcogniitec: {
    title: " BNR Cogniitec Pvt Ltd | Digital Solutions & Development",
    description:
      "BNR Cogniitec Pvt Ltd offers digital marketing, web and app development, CRM, gaming, blockchain, graphic design, and video editing solutions.",
    keywords:
      "BNR Cogniitec Pvt Ltd offers digital marketing, web and app development, CRM, gaming, blockchain, graphic design, and video editing solutions.",
    canonical: `${baseUrl}/bnr-cogniitec`,
  },
  bracademy: {
    title: " BR Academy Pvt Ltd | Training in Tech, Career & Life Skills",
    description:
      " BR Academy Pvt Ltd offers training in technical, non-technical, career, and life skills, empowering students and professionals for future success.",
    keywords:
      " BR Academy Pvt Ltd offers training in technical, non-technical, career, and life skills, empowering students and professionals for future success.",
    canonical: `${baseUrl}/br-academy`,
  },
  skillorea: {
    title: " Health Wellness programe | Home tution | Next gen project",
    description: "Get diverse skills, AI learning, and whole wellness",
    keywords: "Get diverse skills, AI learning, and whole wellness",
    canonical: `${baseUrl}/skillorea`,
  },
  pavalsoft: {
    title: " Paval soft | the Software Power of your network",
    description:
      "Our expertise extends to website development, creating engaging and functional online platforms which represent your brand.",
    keywords:
      "Our expertise extends to website development, creating engaging and functional online platforms which represent your brand.",
    canonical: `${baseUrl}/paval-soft`,
  },
  eventall: {
    title: " Upcoming Events | KTMC, BNR Cogniitec, BR Academy, KTNL",
    description:
      " Explore exciting events by KTMC, BNR Cogniitec, BR Academy, and KTNL, fostering innovation, networking, and growth across various industries.",
    keywords:
      " Explore exciting events by KTMC, BNR Cogniitec, BR Academy, and KTNL, fostering innovation, networking, and growth across various industries.",
    canonical: `${baseUrl}/events`,
  },
  financepartner: {
    title: " KTIG FISCAL ALLIES | Driving Growth, Innovation & Success",
    description:
      "KTIG's fiscal allies drive growth, innovation, and sustainability, providing strategic support and funding to create lasting value for businesses and communities.",
    keywords:
      "KTIG's fiscal allies drive growth, innovation, and sustainability, providing strategic support and funding to create lasting value for businesses and communities.",
    canonical: `${baseUrl}/finance-partner`,
  },
  jointventure: {
    title: " KTIG Co-Venture Associates | Innovation & Growth Partnerships",
    description:
      "KTIG's co-venture associates drive innovation and growth through strategic partnerships, collaboration, and shared expertise for lasting impact.",
    keywords:
      "KTIG's co-venture associates drive innovation and growth through strategic partnerships, collaboration, and shared expertise for lasting impact.",
    canonical: `${baseUrl}/joint-venture-partner`,
  },
  consultingpartner: {
    title: " KTIG Business Consultants | Expert Guidance & Strategic Growth",
    description:
      "KTIG’s business consultants provide expert guidance, strategic insights, and innovative solutions to drive growth, efficiency, and long-term success.",
    keywords:
      "KTIG’s business consultants provide expert guidance, strategic insights, and innovative solutions to drive growth, efficiency, and long-term success.",
    canonical: `${baseUrl}/consulting-partner`,
  },
  sponsershipparner: {
    title: "KTIG Resource Sponsors | Powering Innovation & Growth",
    description:
      "KTIG’s resource sponsors provide vital support, fuelling innovation, growth, and sustainability through strategic resources, technology, and collaboration.",
    keywords:
      "KTIG’s resource sponsors provide vital support, fuelling innovation, growth, and sustainability through strategic resources, technology, and collaboration.",
    canonical: `${baseUrl}/sponsorship-partner`,
  },
  blogall: {
    title: "KTIG Blog | Insights on Innovation, Growth & Industry Trends",
    description:
      " Explore the KTIG Blog for insights on innovation, business growth, and industry trends, helping you stay informed and ahead in a dynamic world.",
    keywords:
      " Explore the KTIG Blog for insights on innovation, business growth, and industry trends, helping you stay informed and ahead in a dynamic world.",
    canonical: `${baseUrl}/blog`,
  },
  contact: {
    title: "Contact KTIG | Connect With Us for Inquiries & Support",
    description:
      " Get in touch with KTIG for inquiries, support, and collaborations. We’re here to assist you with innovative solutions and business growth opportunities.",
    keywords:
      " Get in touch with KTIG for inquiries, support, and collaborations. We’re here to assist you with innovative solutions and business growth opportunities.",
    canonical: `${baseUrl}/contact-us`,
  },
  terms: {
    title: "KTIG Terms & Conditions | Commitment to Integrity & Compliance",
    description:
      "KTIG ensures data privacy, intellectual property protection, and legal compliance, maintaining transparency and professionalism in all engagements.",
    keywords:
      "KTIG ensures data privacy, intellectual property protection, and legal compliance, maintaining transparency and professionalism in all engagements.",
    canonical: `${baseUrl}/terms-conditions`,
  },
  currenopening: {
    title: "KTIG Current Openings | Explore Career Opportunities",
    description:
      "Explore exciting career opportunities at KTIG and join a dynamic team committed to innovation, growth, and excellence across various industries.",
    keywords:
      "Explore exciting career opportunities at KTIG and join a dynamic team committed to innovation, growth, and excellence across various industries.",
    canonical: `${baseUrl}/current-openings`,
  },
  uploadcv: {
    title: " Upload Your CV | Join KTIG for Exciting Career Opportunities",
    description:
      " Upload your CV to KTIG and explore rewarding career opportunities. Join our team and grow with innovation, excellence, and professional development.",
    keywords:
      " Upload your CV to KTIG and explore rewarding career opportunities. Join our team and grow with innovation, excellence, and professional development.",
    canonical: `${baseUrl}/upload-cv`,
  },
  corporateoffice: {
    title: "KTIG Corporate Office | Headquarters & Business Hub",
    description:
      "Visit the KTIG Corporate Office, our central hub for innovation, strategy, and business operations, driving growth and excellence across industries.",
    keywords:
      "Visit the KTIG Corporate Office, our central hub for innovation, strategy, and business operations, driving growth and excellence across industries.",
    canonical: `${baseUrl}/corporate-office`,
  },
  businesshrs: {
    title: "KTIG Business Hours | Office Timing & Availability",
    description:
      "Check KTIG’s business hours to connect with us during our official working times. We’re here to assist you with inquiries and support.",
    keywords:
      "Check KTIG’s business hours to connect with us during our official working times. We’re here to assist you with inquiries and support.",
    canonical: `${baseUrl}/business-hours`,
  },
  privacypolicy: {
    title: "KTIG Privacy Policies | Data Protection & Security Standards",
    description:
      " KTIG ensures data protection, security, and transparency, complying with Indian laws to safeguard client information through strict confidentiality measures.",
    keywords:
      " KTIG ensures data protection, security, and transparency, complying with Indian laws to safeguard client information through strict confidentiality measures.",
    canonical: `${baseUrl}/privacy-policies`,
  },
};

export default metaConfig;
